<template>
	<div class="contentPage">
		<main-table
				v-if="schedulesList && isComponent"
				:flag="flag"
				:pageTitle='title'
				:headers="headers"
				:listItems="schedulesList"
				:filtersList="schedulesFilterList"
				@updateClickButton="onClickButton"
				@updateCreate="onCreate(false)"
				@updateEdit="onEdit"
				@updateSearch="onFilter"
				@updateRefreshFilters="onFilter"
				:updateRefreshFilters="refreshFilters"
				@updateChangeSort="onFilter"
				:uniqId="uniqId"
				isExport
				@updateExport="onExport"
				isSettings
				@updateSettings="onSettingsOpen"
		></main-table>

		<transition name="bounce-reverse">
			<v-container v-if="!isComponent">
				<div class="bounceReverseHead d-flex justify-space-between align-center mb-3">
					<div class="left">
						<h2>Factoring ID: {{ invoiceId }}</h2>
						<span>Total check {{ totalCheck }} $</span>
					</div>
					<div class="right d-flex align-center">
						<span class="ml-auto mr-3">Back</span>
						<v-btn @click="onToggleComponent(true)" fab x-small color="blue">
							<v-icon>double_arrow</v-icon>
						</v-btn>
					</div>
				</div>

				<v-row>
					<v-col cols="12" sm="2" class="pb-0 pt-0">
						<v-select
								color="green"
								v-model="form.customer"
								@change="onCustomer"
								item-text="customer"
								item-value="id"
								:items="customers"
								label="Select Customer"
								:disabled="!!editRow"
								:menu-props="{ bottom: true, nudgeBottom: 34, maxWidth: 280 }"
						>
						</v-select>
					</v-col>
					<v-col cols="12" sm="2" class="pb-0 pt-0">
						<v-text-field
								label="Factoring company"
								type="text"
								v-model="form.company"
								readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="1" class="pb-0 pt-0">
						<v-text-field
								label="Percent"
								type="text"
								v-model="form.percent"
								readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="2" class="pb-0 pt-0">
						<v-select
								color="green"
								v-model="form.payment"
								item-text="name"
								item-value="id"
								:disabled="!paymentTypes.length || !!editRow"
								@change="onPayment"
								:items="paymentTypes"
								label="Payment type"
								:menu-props="{ bottom: true, nudgeBottom: 34, maxWidth: 280 }"
						>
						</v-select>
					</v-col>
					<v-col cols="12" sm="2" class="pb-0 pt-0">
						<v-text-field
								label="Addition amount"
								type="text"
								v-model="form.amount"
								readonly
						></v-text-field>
					</v-col>
					<v-switch
							v-if="editRow"
							v-model="form.processed"
							label="Processed"
							:disabled="!permissions['9'] && permissions['10']"
							color="success"
							hide-details
					></v-switch>
				</v-row>
				<v-row>
					<loads
							v-if="listCargo.length"
							:permissions="permissions"
							@updateRemoveCargoId="onRemoveCargoId"
							@updateRemoveAll="onRemoveAll"
							isLoads
							:editRow="editRow"
							:filtersList="{}"
							:listItems="listCargo"
							:processed="form.processed"
					></loads>
				</v-row>
				<v-row>
					<loads
							v-if="leadsList.length && !form.processed"
							:permissions="permissions"
							@updateCargoId="onCargoId"
							@updateAddAll="onAddAll"
							:filtersList="{}"
							:editRow="editRow"
							:listItems="leadsList"
					></loads>
				</v-row>
				<v-row v-if="(listCargo.length && form.payment)">
					<v-col offset="11">
						<v-btn
								v-if="!!editRow && permissions['9'] || !editRow && permissions['8']"
								@click="onSafe"
								:disabled="!!isFrozen || loading"
								color="green"
								x-small
						>
							{{ editRow ? 'Save form' : 'Create form' }}
						</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</transition>

		<v-dialog v-model="showSend" max-width="300px" class="dialog_emails">
			<v-card-title class="headline green mb-2 ">
				<span class="headline">Send schedules to email</span>
			</v-card-title>
			<v-card>
				<v-col class="d-flex justify-center flex-column align-center justify-center">
					<v-card-text v-for="(email, index) in forEmails" :key="index" :class="{'wrapper': index === 0}">
						<div class="d-flex flex-row align-center justify-center">
							<v-text-field
									placeholder="Enter email"
									label="E-mail"
									v-model="email.mail"
									:rules="mailRules"
							></v-text-field>
							<v-btn
									v-if="index < 1"
									icon
									color="green lighten-1"
									class="ml-4 mt-4"
									small
									type="button"
									@click="forEmails.unshift({mail:''})"
							>
								<v-icon>mdi-plus</v-icon>
							</v-btn>
							<v-btn
									v-if="index > 0"
									icon
									color="green lighten-1"
									class="ml-4 mt-4"
									x-small
									type="button"
									@click="deleteEmails(email)"
							>
								<v-icon color="grey" dense>mdi-delete</v-icon>
							</v-btn>
						</div>
					</v-card-text>
				</v-col>
				<v-col>
					<v-textarea
							name="cover"
							filled
							label="Cover letter"
							auto-grow
							v-model="message"
					></v-textarea>
				</v-col>
				<v-col class="d-flex justify-center">
					<v-card-actions class="card-actions">
						<v-btn text color="primary" @click="cancelSendForm">Cancel</v-btn>
						<v-btn text color="primary" @click="sendEmails">Send</v-btn>
					</v-card-actions>
				</v-col>
			</v-card>
		</v-dialog>
		<preview-doc v-if="link" @clear-link="clearLink" :link-doc="link"/>
		<schedules-popup
				:isSchedulesPopup="isSchedulesPopup"
				@updateFile="onPreview"
				@updateClose="onSchedulesPopup"
				:filesList="filesList"
		></schedules-popup>
		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="settings"
		></table-settings>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import Loads from "@/components/Accounting/Schedules/Loads/Loads";
import PreviewDoc from "@/modules/invoices/preview";
import SchedulesPopup from "@/components/Accounting/Schedules/SchedulesPopup/SchedulesPopup";
const TableSettings = () => import("@/shared/TableSettings/TableSettings");

// constants
import { getAppUrl } from "@/services";
import getUniqId from "@/helper/getUniqId";

export default {
	name: "Schedules",
	components: {
		Loads,
		PreviewDoc,
		SchedulesPopup,
		TableSettings
	},
	computed: {
		...mapGetters([
			'schedulesList',
			'customers',
			'schedulesFilterList',
			'permissions',
			'schedulesSettingsDefault',
			'schedulesSettings',
			'schedulesHeaders',
		]),
		settings() {
			return this.schedulesSettings;
		},
		headers() {
			return this.schedulesHeaders;
		},
		getDriverActions() {
			return this.driverActions && this.driverActions.list.filter(action => action.status !== 0);
		},
		getFilters() {
			return this.filters;
		},
		getEmployees() {
			return this.employees;
		},
		getItems() {
			return this.schedulesList;
		},
		totalCheck() {
			const sumGross = this.listCargo.reduce((acc, item) => {
				acc += parseInt(item.gross);

				return acc;
			}, 0);

			const percent = parseFloat(this.form.percent) / 100;
			const computedPercent = Number.isNaN(percent) ? 0 : percent;

			const sum = sumGross ? sumGross - (sumGross * computedPercent) - +this.form.amount : 0;
			return Number.isNaN(sum) ? 0 : sum;
		}
	},
	data: () => ({
		refreshFilters: false,
		flag: "schedules",
		title: "Schedules",
		isFrozen: null,
		loading: false,
		isComponent: true,
		calendarList: [],
		toggleComponent: true,
		isDrawer: null,
		invoiceId: "new",
		isDialog: false,
		dataActions: null,
		dataSort: {},
		paymentTypes: [],
		leadsList: [],
		listCargo: [],
		editRow: null,
		form: {
			customer: null,
			company: null,
			percent: null,
			payment: null,
			amount: null,
			processed: false
		},
		sendId: null,
		showSend: false,
		forEmails: [ { mail: '' } ],
		mailRules: [ (v) => /^$|.+@.+\..+/.test(v) || "E-mail must be valid" ],
		message: '',
		filesList: [],
		isSchedulesPopup: false,
		link: null,
		isTableSettingsDrawer: false,
		uniqId: null,
	}),
	methods: {
		...mapActions([
			'getSchedulesList',
			'createSchedule',
			'onEditSchedule',
			'onTotalEditSchedules',
			'setWarning',
			'onSafeSchedules',
			'onSchedulesFilter',
			'getSchedulesItem',
			'getSchedulesZip',
			'onExportLink',
			'onSchedulesSettingsReset',
			'onSchedulesSettingsSave',
			'onSchedulesSettingsAll',
		]),
		async onSettingsCancel() {
			this.onSettingsClose();
			await this.onSchedulesSettingsReset();
		},
		onSettingsClose() {
			this.isTableSettingsDrawer = false;
		},

		async onSettingsSave() {
			await this.onSchedulesSettingsSave();
			this.uniqId = getUniqId();
		},
		async onSettingsAll(value) {
			await this.onSchedulesSettingsAll(value);
		},
		onSettingsOpen() {
			this.isTableSettingsDrawer = true;
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'schedules' });
		},

		async onFilter(info) {
			await this.onSchedulesFilter(info.filterModList);
		},
		async onClickButton({ key, item }) {
			if (key === "send") {
				this.onSend(item.id);
			}
			if (key === "visibility") {
				this.getLoadList(item.id);
			}
			if (key === "save_alt") {
				this.onDownload(item.id);
			}
		},
		async onEdit(onValue) {
			const { id } = onValue.line;
			if (this.permissions['10'] || this.permissions['9']) {
				this.invoiceId = id;
				this.editRow = await this.onEditSchedule(id);
				this.editRow.id = id;
				this.isComponent = false;
				const { schedules, load_schedules, loads_all } = this.editRow;

				this.form = {
					customer: { id: schedules.customer_id },
					company: schedules.factoring,
					percent: schedules['factoring_percent'],
					amount: schedules['payment_types_amount'],
					processed: Boolean(schedules.processed)
				};

				const item = this.customers.find(item => item.id === schedules.customer_id);
				this.paymentTypes = item['payment_types'];
				this.isFrozen = item.frozen;

				if (this.isFrozen) {
					await this.setWarning({
						type: "error",
						message: "Error! The customer’s balance is too low",
					});
				} else {
					await this.setWarning(null);
				}

				this.form.payment = { id: schedules['payment_types_id'] };

				this.listCargo = load_schedules;
				this.leadsList = loads_all;
			} else {
				return false;
			}
		},
		async onCreate(point) {
			this.invoiceId = "new";
			this.isComponent = point;
			await this.setWarning(null);

			this.isComponent = point;
			if (point) {
				this.reset();
			}
		},

		onSend(id) {
			this.sendId = id;
			this.showSend = true;
		},
		deleteEmails(mail) {
			const index = this.forEmails.findIndex(e => e.mail === mail.mail);
			this.forEmails.splice(index, 1);
		},
		cancelSendForm() {
			this.showSend = false;
			this.forEmails = [ { mail: '' } ];
			this.message = '';
			this.sendId = null;
		},
		async sendEmails() {
			const dataToSend = this.forEmails.filter(e => e.mail !== '');
			const payLoad = {
				emails: dataToSend,
				message: this.message,
				id: this.sendId
			};

			this.cancelSendForm();

			await this.$store.dispatch("actionPreloader", true);
			await this.$store.dispatch('onSentSchedules', payLoad).then(res => {
				if (res.status === 200) {
					this.$store.dispatch("setAlert", {
						type: "success",
						message: "Sent Successfully",
					});
					this.$store.dispatch("actionPreloader", false);
				}
			});
		},
		async getLoadList(id) {
			this.isSchedulesPopup = true;
			const loadFiles = await this.getSchedulesItem(id);
			this.filesList = loadFiles ?? [];
		},
		onSchedulesPopup() {
			this.isSchedulesPopup = false;
		},
		onPreview(file) {
			this.link = file.includes('data:') ? file : getAppUrl + file;
		},
		clearLink() {
			this.link = null;
		},
		async onDownload(id) {
			this.preloader = true;
			const loadFiles = await this.getSchedulesZip(id);
			if (loadFiles) {
				// const url = new Blob([ loadFiles ], { type: 'application/zip' });
				const link = document.createElement('a');
				// link.href = url;
				link.href = loadFiles;
				link.download = loadFiles;
				link.click();
			}
			this.preloader = false;
		},

		onCustomer() {
			const item = this.customers.find(item => item.id === this.form.customer);
			this.isFrozen = item.frozen;
			this.listCargo = [];

			if (this.isFrozen) {
				this.setWarning({
					type: "error",
					message: "Error! The customer’s balance is too low"
				});
			} else {
				this.setWarning(null);
			}

			const percent = item['factoring_percent'] ? `${ item['factoring_percent'] } %` : null;

			this.form = {
				...this.form,
				company: item.factoring,
				amount: null,
				payment: null,
				percent
			};

			this.paymentTypes = item['payment_types'];
			this.leadsList = item.loads;
		},
		onPayment() {
			const item = this.paymentTypes.find(item => item.id === this.form.payment);

			this.form = {
				...this.form,
				amount: item.amount
			};
		},
		reset() {
			this.form = {
				customer: null,
				company: null,
				percent: null,
				payment: null,
				amount: null,
				processed: false
			};

			this.editRow = null;
			this.leadsList = [];
			this.listCargo = [];
		},
		async onToggleComponent(point) {
			this.invoiceId = "new";
			this.isComponent = point;
			await this.setWarning(null);

			this.isComponent = point;
			if (point) {
				this.reset();
			}
		},
		onClose() {
			this.isDialog = false;
			this.dataActions = null;
		},

		updateList(data) {
			this.toggleComponent = !this.toggleComponent;
			this.items.unshift(data.invoice);
		},
		onCargoId(id) {
			if (!id) return false;

			const item = this.leadsList.find(item => item.load_id === id);
			this.leadsList = this.leadsList.filter(item => item.load_id !== id);
			this.listCargo.push(item);
		},
		onRemoveCargoId(id) {
			if (!id) return false;

			const item = this.listCargo.find(item => item.load_id === id);
			this.listCargo = this.listCargo.filter(item => item.load_id !== id);
			this.leadsList.push(item);
		},
		onAddAll() {
			this.listCargo = [ ...this.listCargo, ...this.leadsList ];
			this.leadsList = [];
		},
		onRemoveAll() {
			this.leadsList = [ ...this.listCargo, ...this.leadsList ];
			this.listCargo = [];
		},
		async onSafe() {
			this.loading = true;
			if (this.isFrozen) {
				await this.setWarning({
					type: "error",
					message: "Error! The customer’s balance is too low",
				});
			} else if (this.editRow) {
				const loads = this.listCargo.map(item => {
					const { load_id, purchased = 0 } = item;
					return { load_id, purchased: Number(purchased) };
				});

				const data = {
					processed: Number(this.form.processed),
					loads
				};

				await this.onTotalEditSchedules({ id: this.editRow.id, data });
				await this.getSchedulesList();
				this.isComponent = true;
				this.reset();
				this.refreshFilters = !this.refreshFilters;
			} else {
				const values = {
					customer_id: this.form.customer,
					payment_types_id: this.form.payment,
					processed: Number(this.form.processed),
					loads: this.listCargo
				};

				const { data } = await this.onSafeSchedules(values);

				if (data.customer) {
					this.editRow = await this.onEditSchedule(data.customer);
					this.editRow.id = data.customer;
				}
				await this.getSchedulesList();

				const { schedules, load_schedules, loads_all } = this.editRow;

				this.form = {
					customer: { id: schedules.customer_id },
					company: schedules.factoring,
					percent: schedules['factoring_percent'],
					amount: schedules['payment_types_amount'],
					processed: Boolean(schedules.processed)
				};

				const item = this.customers.find(item => item.id === schedules.customer_id);
				this.paymentTypes = item['payment_types'];

				this.form.payment = { id: schedules['payment_types_id'] };

				this.listCargo = load_schedules;
				this.leadsList = loads_all;
				this.refreshFilters = !this.refreshFilters;
			}

			await this.createSchedule();
			this.loading = false;
		},
	},
	async created() {
		await this.getSchedulesList();
		await this.createSchedule();
	}
};
</script>
<style lang="scss" scoped>
@import "./schedules";
</style>
